'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvg = require('react-svg');

var _reactSvg2 = _interopRequireDefault(_reactSvg);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Robot = function (_PureComponent) {
  _inherits(Robot, _PureComponent);

  function Robot() {
    _classCallCheck(this, Robot);

    return _possibleConstructorReturn(this, (Robot.__proto__ || Object.getPrototypeOf(Robot)).apply(this, arguments));
  }

  _createClass(Robot, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          bsStyle = _props.bsStyle,
          size = _props.size,
          alternate = _props.alternate;
      return _react2.default.createElement('div', {
        className: 'robot robot-' + size
      }, _react2.default.createElement('div', {
        className: 'robot-bg'
      }, _react2.default.createElement(_reactSvg2.default, {
        path: 'https://static.ux.cimpress.io/assets/images/bg_diamond-' + bsStyle + '.svg'
      })), _react2.default.createElement('div', {
        className: 'robot-figure'
      }, _react2.default.createElement(_reactSvg2.default, {
        path: 'https://static.ux.cimpress.io/assets/images/robot-' + bsStyle + (alternate ? '-2' : '') + '.svg'
      })));
    }
  }]);

  return Robot;
}(_react.PureComponent);

exports.default = Robot;
Robot.propTypes = {
  bsStyle: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger']),
  size: _propTypes2.default.oneOf(['sm', 'lg']),
  alternate: _propTypes2.default.bool
};
Robot.defaultProps = {
  bsStyle: 'success',
  size: 'sm'
};